import React, { useState } from 'react';
import { Space, Spin, Button, Badge, List, Row, Grid } from 'antd';
import { RegistrationTeamStatus } from '@vote4dance/judging-types';
import { hooks, models } from "@vote4dance/judging-sdk";
var Stream = hooks.streams.Stream;
var ClassesSource = models.classes.ClassesSource;
var ClassItem = models.classes.ClassItem;
import { CaretUpOutlined, DownOutlined, RightOutlined } from '@ant-design/icons';
import { RegistrationList } from './RegistrationList';
const { useBreakpoint } = Grid;
export const RegistrationTeamList = (props) => {
    const { competition_id } = props;
    const [classes, loading] = Stream(ClassesSource(competition_id));
    if (loading) {
        return React.createElement(Spin, null);
    }
    return (React.createElement(List, { size: 'small', itemLayout: 'vertical', dataSource: (classes === null || classes === void 0 ? void 0 : classes.filter(a => parseInt(a.class_count_registration) > 0)) || [], bordered: true, renderItem: (classItem) => (React.createElement(TeamClassListItem, { competition_id: competition_id, classItem: classItem })) }));
};
const TeamClassListItem = (props) => {
    const { competition_id, classItem } = props;
    const screens = useBreakpoint();
    const [expanded, setExpanded] = useState(false);
    const handleClickExpand = (event) => {
        event.stopPropagation();
        setExpanded(!expanded);
    };
    return (React.createElement(List.Item, { style: { padding: 0 } },
        React.createElement(List.Item.Meta, { style: { marginBottom: 0 }, description: React.createElement(Row, { justify: 'space-between', onClick: handleClickExpand, style: { padding: 8 } },
                React.createElement(Space, null,
                    parseInt(classItem.class_group_id) > 0 &&
                        React.createElement(CaretUpOutlined, null),
                    React.createElement(Button, { type: "text", onClick: handleClickExpand },
                        React.createElement(Space, null,
                            ClassItem.getClassLabel(classItem),
                            screens.sm &&
                                React.createElement(Badge, { overflowCount: 999, count: classItem.class_count_registration })))),
                React.createElement(Space, null, expanded ? React.createElement(DownOutlined, { onClick: handleClickExpand }) : React.createElement(RightOutlined, { onClick: handleClickExpand }))) }),
        expanded &&
            React.createElement(RegistrationList, { competition_id: competition_id, classId: classItem.class_id, statuses: [RegistrationTeamStatus.Approved], disableImport: true })));
};
